module.exports = __webpack_public_path__ + "static/media/icon_delete.7ba425ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_delete.svg
// module id = 747
// module chunks = 0